import React, { useEffect, useState } from "react";
import {
  Card,
  Form,
  InputGroup,
  Button,
  Breadcrumb,
  Pagination,
  Nav,
} from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../../components/UploadImageComponent";
import InputLeftIcon from "../../components/form_item/InputLeftIcon";
import { SuccessSwal } from "../../helpers/alertseet";
import peopleImage from "../../assets/people.jpeg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PopUp from "../../components/popup/PopUp";
import { useStore } from "../../store/useStore";
import { delete_member, get_member } from "../../services/membership.service";
import moment from "moment";
import converSex from "../../helpers/convertSex";
import {
  get_activity_history_by_balance_id,
  get_balance_by_id,
  get_balances,
  sumary_dividend_result,
} from "../../services/balance.service";
import PopUpConfirmDelete from "../../components/popup/PopUpConfirmDelete";
import { END_IMAGE } from "../../constants";
import imageProfileEmpty from "../../assets/profile-empty.webp";
import { get_loan_by_member_id, get_loans } from "../../services/loan.service";
import convertTypeDepositWithdraw from "../../helpers/convertTypeDepositWithdraw";
import convertNumber from "../../helpers/convertNumber";
import convertStatusLoan from "../../helpers/convertStatusLoan";
import cutBranchNo from "../../helpers/cutBranchNo";

export default function DetailMembershipPage() {
  const navigate = useNavigate();
  // state
  const [isLoading, setIsLoading] = useState(true);
  const [tabSelect, setTabSelect] = useState("/detail");
  const [popup, setPopup] = useState();
  const { membershipId } = useParams();
  const [memberData, setMemberData] = useState();
  const [balanceData, setBalanceData] = useState(); //ເງິນອອມ
  const [activityHistoryData, setActivityHistoryData] = useState(); //ເງິນອອມ
  const [loanData, setLoanData] = useState(); //ເງີນກູ້
  const location = useLocation();

  // store
  const { token, setIsLoadingDetailPage } = useStore();
  // useEffect
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchObject = Object.fromEntries(searchParams.entries());

    if (searchObject?.tab === "deposit") {
      setTabSelect("/savings");
    }
  }, [location.search]);

  useEffect(() => {
    getData();
  }, []);
  useEffect(() => {
    console.log("memberData", memberData);
    getActivityHistoryData();
    getLoanData();
  }, [memberData]);

  // function
  const getData = async () => {
    try {
      setIsLoading(true);
      setIsLoadingDetailPage(true);
      const data = await get_member(membershipId+"?allLoan=true", token);
      if (data?.error) throw new Error(data?.message);
      let member = data?.data;

      setMemberData(member);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
      setIsLoadingDetailPage(false);
    }
  };

  const getActivityHistoryData = async () => {
    try {
      if (!memberData?._id) throw new Error("memberId empty");
      setIsLoading(true);
      let findby = "?";
      findby += `memberId=${memberData?._id}`;
      // findby += `memberNo=${memberData?.memberNo}`;
      const data = await get_activity_history_by_balance_id(findby, token);
      if (data?.error) throw new Error(data?.message);

      let _res = data?.data;
      setActivityHistoryData(_res);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const getLoanData = async () => {
    try {
      if (!memberData?._id) throw new Error("memberId empty");
      setIsLoading(true);
      let findby = "?";
      // findby += `memberId=${memberData?._id}`;
      findby += `memberNo=${memberData?.memberNo}`;
      // const data = await get_loan_by_member_id(findby, token);
      const data = await get_loans(findby, token);
      if (data?.error) throw new Error(data?.message);

      let _res = data?.data;
      setLoanData(_res);
      console.log("loan", _res);
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  const handleDelete = async () => {
    await delete_member(membershipId, token);
    navigate("/membership", { replace: true });
  };
  const handleSubmitSumaryDividend = async (formData) => {
    try {
      setIsLoading(true);
      await sumary_dividend_result(memberData?._id, formData, token);
      getData();
      setIsLoading(false);
    } catch (err) {
      console.error("error", err);
      setIsLoading(false);
    }
  };
  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => navigate("/membership", { replace: true })}
        >
          ບັນຊີສະມາຊິກ
        </Breadcrumb.Item>
        <Breadcrumb.Item active>ລາຍລະອຽດບັນຊີ</Breadcrumb.Item>
      </Breadcrumb>
      <Nav variant="tabs" activeKey={tabSelect} onSelect={setTabSelect}>
        <Nav.Item>
          <Nav.Link eventKey="/detail">ລາຍລະອຽດ</Nav.Link>
        </Nav.Item>
        {/* <Nav.Item>
          <Nav.Link eventKey="/savings">ເງິນອອມ</Nav.Link>
        </Nav.Item> */}
        <Nav.Item>
          <Nav.Link eventKey="/loan">ເງິນກູ້ ແລະ ຊຳລະຄືນ</Nav.Link>
        </Nav.Item>
      </Nav>
      {/* ລາຍລະອຽດ */}
      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
          borderRadius: "0px 8px 8px 8px",
          display: tabSelect === "/detail" ? "block" : "none",
        }}
      >
        <div style={{ display: "flex", gap: 20, justifyContent: "flex-end" }}>
          <Button
            variant="outline-danger"
            onClick={() => setPopup({ PopUpConfirmDelete: true })}
            size="md"
          >
            ລຶບ
          </Button>
          <Button
            onClick={() => navigate(`/membership/update/${membershipId}`)}
            size="md"
          >
            ແກ້ໄຂ
          </Button>
        </div>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "auto 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <h2>ຮູບພາບ</h2>
            <div
              style={{
                borderRadius: 8,
                overflow: "hidden",
                width: 160,
                height: 160,
              }}
            >
              <img
                src={
                  memberData?.profileImage
                    ? END_IMAGE + memberData?.profileImage
                    : imageProfileEmpty
                }
                alt=""
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <h2>ຂໍ້ມູນສ່ວນໂຕ</h2>
            {[
              {
                title: "ເລກສະມາຊິກ:",
                value: memberData?.memberNo
                  ? cutBranchNo(memberData?.memberNo)
                  : "-",
              },
              { title: "ຊື່:", value: memberData?.firstName || "-" },
              { title: "ນາມສະກຸນ:", value: memberData?.lastName || "-" },
              {
                title: "ເພດ:",
                value: memberData?.gender ? converSex(memberData?.gender) : "-",
              },
              {
                title: "ວັນເດືອນປີເກີດ:",
                value: memberData?.birthday
                  ? moment(memberData?.birthday).format("DD/MM/YYYY")
                  : "-",
              },
              { title: "ອາຊີບ:", value: memberData?.occupation || "-" },
              { title: "ໜ່ວຍ:", value: memberData?.homeUnit || "-" },
              { title: "ເຮືອນເລກທີ:", value: memberData?.homeNumber || "-" },
              { title: "ບ້ານ:", value: memberData?.village || "-" },
              { title: "ເມືອງ:", value: memberData?.district || "-" },
              { title: "ແຂວງ:", value: memberData?.province || "-" },
              {
                title: "ສຳມະໂນຄົວເລກທີ:",
                value: memberData?.familyNumber || "-",
              },
              {
                title: "ລົງວັນທີ:",
                value: memberData?.createdAt
                  ? moment(memberData?.createdAt).format("DD/MM/YYYY")
                  : "-",
              },
              {
                title: "ກິດຈະກຳສ້າງລາຍຮັບ:",
                value: memberData?.incomeActivity || "-",
              },
              { title: "ເບີໂທ:", value: memberData?.phone || "-" },
              {
                title: "ຜູ້ສ້າງ:",
                value: memberData?.createdBy?.fullName || "-",
              },
            ].map((e, i) => (
              <div className="list-data-profile" key={i}>
                <div>{e?.title}</div>
                <div>{e?.value}</div>
              </div>
            ))}

            <br />
            <br />
          </div>
        </div>
      </Card>
      {/* ເງິນອອມ */}
      {/* <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
          borderRadius: "0px 8px 8px 8px",
          display: tabSelect === "/savings" ? "block" : "none",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>ຂໍ້ມູນເບື້ອງຕົ້ນ</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
            marginBottom: 36,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value: memberData?.fullName || "-",
                },
                {
                  title: "ເພດ:",
                  value: memberData?.gender
                    ? converSex(memberData?.gender)
                    : "-",
                },
                { title: "ເບີໂທ:", value: memberData?.phone || "-" },
                { title: "ເລກສະມາຊິກ:", value: memberData?.memberNo || "-" },
              ].map((e, i) => (
                <div className="list-data-profile" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ຍອດຄົງເຫຼືອ (ກີບ):",
                  value: memberData?.balanceId?.totalBalance
                    ? convertNumber(memberData?.balanceId?.totalBalance)
                    : "-",
                },
                {
                  title: "ຄະແນນທີ່ມີ:",
                  value: memberData?.balanceId?.totalPoint
                    ? convertNumber(memberData?.balanceId?.totalPoint)
                    : "-",
                },
                {
                  title: "ເງິນຕອບແທນທີ່ຈະໄດ້ (ກີບ):",
                  value: memberData?.balanceId?.totalDividendAmount
                    ? convertNumber(memberData?.balanceId?.totalDividendAmount)
                    : "-",
                },
              ].map((e, i) => (
                <div className="list-data-profile" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <h2 style={{ marginBottom: "20px" }}>ຕາຕະລາງການເຄື່ອນໄຫວຂອງສະມາຊິກ</h2>
        <div
          style={{
            display: "flex",
            marginBottom: "20px",
            gap: 10,
            alignItems: "flex-end",
          }}
        >
          <div style={{ flex: 1 }}></div>
          <div>
            <Button onClick={() => setPopup({ punphone: true })} size="md">
              ມອບເງິນປັນຜົນ
            </Button>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ລະຫັດລາຍການ</th>
                <th style={{ textAlign: "end" }}>ສະຖານະ</th>
                <th style={{ textAlign: "end" }}>ທຸລະກຳ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຍອດຄົງເຫຼືອ (ກີບ)</th>
                <th>ຄະແນນ</th>
                <th>ວັນທີເຄື່ອນໄຫວ</th>
                <th>ຜູ້ສ້າງລາຍການ</th>
              </tr>
            </thead>
            <tbody>
              {activityHistoryData?.map((e, i) => (
                <tr
                  onClick={() => navigate(`/membership/detail/${membershipId}`)}
                  key={i}
                >
                  <td>{e?.activityHistoryNo || "-"}</td>
                  <td style={{ textAlign: "end" }}>
                    {e?.activityHistoryType
                      ? convertTypeDepositWithdraw(e?.activityHistoryType)
                      : "-"}
                  </td>
                  <td
                    style={{
                      textAlign: "end",
                      color:
                        e?.activityHistoryType !== "WITHDRAW"
                          ? "#0DCD5A"
                          : "#FF0000",
                    }}
                  >
                    {e?.activityHistoryType !== "WITHDRAW" ? "+" : "-"}
                    {e?.balanceAmount ? convertNumber(e?.balanceAmount) : "-"}
                  </td>
                  <td style={{ textAlign: "end" }}>
                    {e?.currentTotalBalance
                      ? convertNumber(e?.currentTotalBalance)
                      : "-"}
                  </td>
                  <td>
                    {e?.currentTotalPoint
                      ? convertNumber(e?.currentTotalPoint)
                      : "-"}
                  </td>
                  <td>
                    {e?.createdAt
                      ? moment(e?.createdAt).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </td>
                  <td>{e?.createdBy?.fullName || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card> */}
      {/* ເງິນກູ້ ແລະ ຊຳລະຄືນ */}
      <Card
        style={{
          padding: "20px 20px",
          minHeight: "80dvh",
          position: "relative",
          paddingBottom: 150,
          borderRadius: "0px 8px 8px 8px",
          display: tabSelect === "/loan" ? "block" : "none",
        }}
      >
        <h2 style={{ marginBottom: "20px" }}>ຂໍ້ມູນສ່ວນໂຕ</h2>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 20,
            gridGap: 20,
            width: "100%",
            marginBottom: 36,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ຊື່ ແລະ ນາມສະກຸນ:",
                  value: memberData?.fullName || "-",
                },
                {
                  title: "ເພດ:",
                  value: memberData?.gender
                    ? converSex(memberData?.gender)
                    : "-",
                },
                { title: "ເບີໂທ:", value: memberData?.phone || "-" },
                { title: "ເລກສະມາຊິກ:", value: memberData?.memberNo || "-" },
              ].map((e, i) => (
                <div className="list-data-profile" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {[
                {
                  title: "ຈຳນວນເງິນກູ້ທັງໝົດ (ກີບ):",
                  value: memberData?.LoanAllRecord
                    ? convertNumber(memberData?.LoanAllRecord)
                    : "-",
                },
                { title: "ຈຳນວນເງິນທີ່ຊຳລະ (ກີບ):", value: memberData?.LoanSuccess
                    ? convertNumber(memberData?.LoanSuccess)
                    : "-", },
                { title: "ຈຳນວນເງິນຍັງບໍ່ໄດ້ຊຳລະ (ກີບ):", value: memberData?.Loan
                    ? convertNumber(memberData?.Loan)
                    : "-", },
              ].map((e, i) => (
                <div className="list-data-profile" key={i}>
                  <div>{e?.title}</div>
                  <div>{e?.value}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <h2 style={{ marginBottom: "20px" }}>ຕາຕະລາງປ່ອຍກູ້ ແລະ ເກັບຄືນ</h2>
        <div
          style={{
            display: "flex",
            marginBottom: "20px",
            gap: 10,
            justifyContent: "s",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Form.Label>ສະແດງຕາມ</Form.Label>
            <Form.Select value="ທັງໝົດ">
              <option value="ລໍຖ້າຊຳລະ">ລໍຖ້າຊຳລະ</option>
              <option value="ບໍ່ຮອດມື້ຊຳລະ">ບໍ່ຮອດມື້ຊຳລະ</option>
              <option value="ຊຳລະທີ່ສຳເລັດ">ຊຳລະທີ່ສຳເລັດ</option>
              <option value="ທັງໝົດ">ທັງໝົດ</option>
            </Form.Select>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <table style={{ width: "100%" }}>
            <thead>
              <tr>
                <th>ລະຫັດລາຍການ</th>
                <th>ງວດຊຳລະ</th>
                <th style={{ textAlign: "end" }}>ຈຳນວນເງິນທີ່ຊຳລະ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>ຈຳນວນເງິນກູ້ (ກີບ)</th>
                <th style={{ textAlign: "end" }}>
                  ຈຳນວນເງິນທີ່ຍັງບໍ່ຊຳລະ (ກີບ)
                </th>
                <th>ສະຖານະ</th>
                <th>ວັນເວລາປ່ອຍກູ້</th>
                <th>ຜູ້ສ້າງລາຍການ</th>
              </tr>
            </thead>
            <tbody>
              {loanData?.map((e, i) => (
                <tr onClick={() => navigate(`/loan/detail/${e?._id}`)} key={i}>
                  <td>{e?.loanNo || "-"}</td>
                  <td>
                    <span style={{ color: "#0178C1" }}>
                      {e?.latestInstallmentNote?.installmentNoteNo || "-"}
                    </span>{" "}
                    / {e?.loanTerm || "-"}
                  </td>
                  <td style={{ color: "#0178C1", textAlign: "end" }}>
                    {e?.totalRepaymentAmount
                      ? convertNumber(e?.totalRepaymentAmount)
                      : "-"}
                  </td>
                  <td style={{ textAlign: "end" }}>
                    {e?.loanAmount ? convertNumber(e?.loanAmount) : "-"}
                  </td>
                  <td style={{ textAlign: "end" }}>-</td>
                  <td>
                    {e?.loanStatus ? convertStatusLoan(e?.loanStatus) : "-"}
                  </td>
                  <td>
                    {e?.createdAt
                      ? moment(e?.createdAt).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </td>
                  <td>{e?.createdBy?.fullName || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      {/* ສ່ວນຂອງ popup */}
      <PopUp
        open={popup?.punphone}
        onClose={() => setPopup()}
        memberData={memberData}
        onSubmit={handleSubmitSumaryDividend}
      />
      <PopUpConfirmDelete
        open={popup?.PopUpConfirmDelete}
        onClose={() => setPopup()}
        onSubmit={handleDelete}
        title={"ລຶບບັນຊີ!"}
        sub={
          <span>
            ທ່ານຕ້ອງການລຶບບັນຊີ{" "}
            <span style={{ fontWeight: 700 }}>{memberData?.fullName}</span>{" "}
            ນີ້ແທ້ບໍ່?
          </span>
        }
      />
    </div>
  );
}
